/* ============================================================
   THE ARA ATELIER — content model (English / Spanish)
   All site copy lives here. US English spelling throughout.
   ============================================================ */

/* ---------- the colors we work in ---------- */
/* No "all" swatch. The book always stands in one colour — a dealer shows
   you the stone in the colour you asked for, not a contact sheet. White
   (D–J) is where it opens. */
window.ARA_COLORS = [
  { key:"white",     en:"White",      es:"Blanco",    hex:"#F2F4F6", grade_en:"D – J",         grade_es:"D – J" },
  { key:"yellow",    en:"Yellow",     es:"Amarillo",  hex:"#DFB847", grade_en:"Fancy Vivid",   grade_es:"Fancy Vivid" },
  { key:"pink",      en:"Pink",       es:"Rosa",      hex:"#DF9CA4", grade_en:"Fancy Intense", grade_es:"Fancy Intense" },
  { key:"blue",      en:"Blue",       es:"Azul",      hex:"#6E8EA8", grade_en:"Fancy Deep",    grade_es:"Fancy Deep" },
  { key:"green",     en:"Green",      es:"Verde",     hex:"#94AC8E", grade_en:"Fancy",         grade_es:"Fancy" },
  { key:"orange",    en:"Orange",     es:"Naranja",   hex:"#D7924F", grade_en:"Fancy Vivid",   grade_es:"Fancy Vivid" },
  { key:"purple",    en:"Purple",     es:"Morado",    hex:"#A892B8", grade_en:"Fancy",         grade_es:"Fancy" },
  { key:"champagne", en:"Champagne",  es:"Champán",   hex:"#C09A6D", grade_en:"Fancy Light",   grade_es:"Fancy Light" },
  { key:"gray",      en:"Gray",       es:"Gris",      hex:"#8A939C", grade_en:"Fancy",         grade_es:"Fancy" }
];

/* ---------- what we make, and how the stone sits in it ----------
   The price COLUMN each style maps to is `col`, matching prices.js.
   `add` is a surcharge in whole dollars for a style the workbook has no
   column for. `band` pins a style to one carat row when the piece takes
   no stone at all. Both languages live on the same row so they cannot
   drift apart. The Worker carries the same k/col/add mapping and will
   refuse any combination that is not here.
   ---------------------------------------------------------------- */
window.ARA_PIECES = [
  { k:"chain", en:"Chain", es:"Cadena", noStone:true,
    hint_en:"The chain on its own.", hint_es:"Solo la cadena.",
    styles:[
      { k:"cable", en:"Cable", es:"Cable", col:"chain", band:"0.10\u20130.50" }
    ] },

  { k:"pendant", en:"Pendant", es:"Colgante",
    hint_en:"Set and hung.", hint_es:"Engastado y colgado.",
    styles:[
      { k:"solitaire", en:"Solitaire", es:"Solitario", col:"pendant" },
      { k:"bezel",     en:"Bezel",     es:"Bisel",     col:"pendant-bezel" }
    ] },

  { k:"ring", en:"Ring", es:"Anillo",
    hint_en:"Built to your finger.", hint_es:"Hecho a su medida.",
    styles:[
      { k:"solitaire",       en:"Solitaire",                   es:"Solitario",                        col:"ring" },
      { k:"bezel",           en:"Bezel",                       es:"Bisel",                            col:"ring-bezel" },
      { k:"solitaire-sides", en:"Solitaire with side diamonds", es:"Solitario con diamantes laterales", col:"ring-sides" },
      { k:"bezel-sides",     en:"Bezel with side diamonds",     es:"Bisel con diamantes laterales",     col:"ring-sides", add:100 }
    ] },

  { k:"earrings", en:"Earrings", es:"Aretes",
    hint_en:"Priced as a pair.", hint_es:"Precio por par.",
    styles:[
      { k:"solitaire", en:"Solitaire", es:"Solitario", col:"earrings" },
      { k:"halo",      en:"Halo",      es:"Halo",      col:"earrings-dia" }
    ],
    backs:[
      { k:"push",  en:"Push back",  es:"Cierre de presi\u00f3n" },
      { k:"screw", en:"Screw back", es:"Cierre de rosca" }
    ] }
];

/* ---------- the book of cuts ----------
   cut  : brilliant | step | rose | mixed     (how it is faceted)
   shape: round | oval | pear | marquise | square | geometric | side
   geometry in a 100 × 120 box; p = polygon points, d = path, e = ellipse [rx,ry]
   ------------------------------------------------------------------ */
window.ARA_CUTS = [
  { en:"Round brilliant", es:"Redondo brillante", cut:"brilliant", shape:"round", e:[44,44], facets:57 },
  { en:"Portuguese",      es:"Portuguesa",        cut:"brilliant", shape:"round", e:[44,44], facets:161, house:true },
  { en:"Old European",    es:"Europeo antiguo",   cut:"brilliant", shape:"round", e:[43,43], facets:58 },
  { en:"Rose cut",        es:"Corte rosa",        cut:"rose",      shape:"round", e:[44,44], facets:24 },

  { en:"Oval",            es:"Oval",              cut:"brilliant", shape:"oval", e:[33,52], facets:58 },
  { en:"Moval",           es:"Moval",             cut:"brilliant", shape:"oval", d:"M50 8C68 8 80 30 80 60C80 90 68 112 50 112C32 112 20 90 20 60C20 30 32 8 50 8Z", facets:58 },
  { en:"Oval step",       es:"Oval escalonado",   cut:"step",      shape:"oval", e:[33,52], facets:34 },
  { en:"Moval step",      es:"Moval escalonado",  cut:"step",      shape:"oval", d:"M50 8C68 8 80 30 80 60C80 90 68 112 50 112C32 112 20 90 20 60C20 30 32 8 50 8Z", facets:34 },

  { en:"Pear",            es:"Pera",              cut:"brilliant", shape:"pear", d:"M50 8C70 34 86 52 86 74C86 96 70 112 50 112C30 112 14 96 14 74C14 52 30 34 50 8Z", facets:58 },
  { en:"Rose pear",       es:"Pera rosa",         cut:"rose",      shape:"pear", d:"M50 8C70 34 86 52 86 74C86 96 70 112 50 112C30 112 14 96 14 74C14 52 30 34 50 8Z", facets:22 },
  { en:"Step cut pear",   es:"Pera escalonada",   cut:"step",      shape:"pear", d:"M50 8C70 34 86 52 86 74C86 96 70 112 50 112C30 112 14 96 14 74C14 52 30 34 50 8Z", facets:36 },
  { en:"Heart",           es:"Corazón",           cut:"brilliant", shape:"pear", d:"M50 112C16 86 10 62 10 46C10 28 21 18 33 18C41 18 47 24 50 32C53 24 59 18 67 18C79 18 90 28 90 46C90 62 84 86 50 112Z", facets:59 },

  { en:"Marquise",        es:"Marquesa",          cut:"brilliant", shape:"marquise", d:"M50 6C72 30 84 46 84 60C84 74 72 90 50 114C28 90 16 74 16 60C16 46 28 30 50 6Z", facets:58 },
  { en:"Dutch marquise",  es:"Marquesa holandesa",cut:"brilliant", shape:"marquise", d:"M50 4C78 34 90 52 90 65C90 78 78 96 50 116C22 96 10 78 10 65C10 52 22 34 50 4Z", facets:58, house:true },
  { en:"Marquise step",   es:"Marquesa escalonada",cut:"step",     shape:"marquise", d:"M50 6C72 30 84 46 84 60C84 74 72 90 50 114C28 90 16 74 16 60C16 46 28 30 50 6Z", facets:36 },
  { en:"Lozenge",         es:"Rombo",             cut:"step",      shape:"marquise", p:"50,8 82,60 50,112 18,60", facets:24 },

  { en:"Princess",        es:"Princesa",          cut:"mixed",     shape:"square", p:"14,24 86,24 86,96 14,96", facets:76 },
  { en:"Cushion",         es:"Cojín",             cut:"mixed",     shape:"square", d:"M28 14H72C86 14 90 24 90 38V82C90 96 86 106 72 106H28C14 106 10 96 10 82V38C10 24 14 14 28 14Z", facets:64 },
  { en:"Radiant",         es:"Radiante",          cut:"mixed",     shape:"square", p:"30,14 70,14 88,32 88,88 70,106 30,106 12,88 12,32", facets:70 },
  { en:"Emerald",         es:"Esmeralda",         cut:"step",      shape:"square", p:"30,10 70,10 84,24 84,96 70,110 30,110 16,96 16,24", facets:58 },
  { en:"Asscher",         es:"Asscher",           cut:"step",      shape:"square", p:"30,22 70,22 86,38 86,82 70,98 30,98 14,82 14,38", facets:58 },
  { en:"Sapphire cut",    es:"Corte zafiro",      cut:"step",      shape:"square", p:"34,12 66,12 86,30 86,90 66,108 34,108 14,90 14,30", facets:48 },
  { en:"Baguette",        es:"Baguette",          cut:"step",      shape:"square", p:"26,16 74,16 74,104 26,104", facets:14 },
  { en:"Tapered baguette",es:"Baguette cónica",   cut:"step",      shape:"square", p:"34,16 66,16 76,104 24,104", facets:14 },
  { en:"Ashoka",          es:"Ashoka",            cut:"step",      shape:"square", d:"M30 10H70C82 10 88 22 88 40V80C88 98 82 110 70 110H30C18 110 12 98 12 80V40C12 22 18 10 30 10Z", facets:62 },

  { en:"Hexagon",         es:"Hexágono",          cut:"step",      shape:"geometric", p:"50,8 88,32 88,88 50,112 12,88 12,32", facets:32 },
  { en:"Long hexagon",    es:"Hexágono largo",    cut:"step",      shape:"geometric", p:"50,4 82,28 82,92 50,116 18,92 18,28", facets:32 },
  { en:"Octagon",         es:"Octágono",          cut:"step",      shape:"geometric", p:"34,10 66,10 90,34 90,86 66,110 34,110 10,86 10,34", facets:40 },
  { en:"Decagon",         es:"Decágono",          cut:"step",      shape:"geometric", p:"50,8 76,17 92,40 92,80 76,103 50,112 24,103 8,80 8,40 24,17", facets:44 },
  { en:"Pentagon",        es:"Pentágono",         cut:"step",      shape:"geometric", p:"50,10 92,44 76,104 24,104 8,44", facets:28 },
  { en:"Kite",            es:"Cometa",            cut:"step",      shape:"geometric", p:"50,6 88,48 50,114 12,48", facets:20, house:true },
  /* A shield's widest point is its flat top edge. The sides taper inward
     from the top corners to a single point — they never flare out below it.
     The old outline had shoulders, which is a coat of arms, not a cut. */
  { en:"Shield",          es:"Escudo",            cut:"step",      shape:"geometric", p:"14,16 86,16 82,48 68,78 50,108 32,78 18,48", facets:24 },
  { en:"Trilliant",       es:"Trillante",         cut:"brilliant", shape:"geometric", p:"50,10 92,102 8,102", facets:44 },
  { en:"Cadillac",        es:"Cadillac",          cut:"step",      shape:"geometric", p:"50,8 84,38 76,104 24,104 16,38", facets:26 },

  { en:"Half moon",       es:"Media luna",        cut:"brilliant", shape:"side", d:"M12 34H88A42 56 0 0 1 12 34Z", facets:22, house:true },
  { en:"Bullet",          es:"Bala",              cut:"step",      shape:"side", d:"M20 16H80V72C80 96 68 110 50 110C32 110 20 96 20 72Z", facets:18 },
  { en:"Calf",            es:"Calf",              cut:"step",      shape:"side", p:"26,14 74,14 68,108 32,108", facets:16 },
  /* --- antique and geometric additions --- */
  /* squarer and smaller in the frame than the cushion above it, the way an
     old mine actually sits next to a modern cushion */
  { en:"Old mine",        es:"Mina antigua",      cut:"brilliant", shape:"square",
    d:"M30 22H70C82 22 88 30 88 42V78C88 90 82 98 70 98H30C18 98 12 90 12 78V42C12 30 18 22 30 22Z",
    facets:58, house:true },
  /* six-pointed, matching the photograph */
  { en:"Star",            es:"Estrella",          cut:"step",      shape:"geometric",
    p:"50,14 61.5,40.1 89.8,37 73,60 89.8,83 61.5,79.9 50,106 38.5,79.9 10.2,83 27,60 10.2,37 38.5,40.1",
    facets:36 }
];

/* ============================================================
   COPY
   ============================================================ */
window.ARA_CONTENT = {

/* ------------------------------------------------------------------ EN */
en: {
  code:"en",
  nav:{ home:"Home", book:"The Book", diamond:"The Diamond", custom:"Made to Order",
        worn:"Worn", vault:"The Vault", journal:"Journal", house:"The House",
        careers:"Careers", contact:"Contact" },

  /* the title block that stands where the hero stands on the home page */
  heads:{
    book:    { h:"The Book",      lede:"Thirty-nine cuts, every one photographed on black. Choose a color and the whole book turns." },
    diamond: { h:"The Diamond",   lede:"Same carbon. Same hardness. Same certificate. A shorter story, and nobody had to dig for it." },
    custom:  { h:"Made to Order", lede:"You choose the stone. We draw the setting, you approve the drawing, and our bench builds it." },
    worn:    { h:"Worn",          lede:"What the stones become once somebody chooses one." },
    vault:   { h:"The Vault",     lede:"Loose stones ready to set \u2014 and the finished pieces coming into The Cabinet." },
    house:   { h:"The House",     lede:"A tray, a loupe, and a table in New York City." },
    careers: { h:"Careers",       lede:"Small house, long hours, real stones. If that reads as an invitation rather than a warning, send us your resume." },
    journal: { h:"The Journal",   lede:"Every commission, written up: the stone, the brief, the metal, and what came off the bench." },
    contact: { h:"Contact",       lede:"Write to us. Every message is answered within 24 hours, in English or Spanish." }
  },

  /* ---------- the setting configurator ---------- */
  config:{
    eyebrow:"The setting",
    h:"Price your <em>mounting.</em>",
    body:"A few questions \u2014 how many depends on what you are making. The price appears as you answer them, and it is the real price: the same chart we quote from on the phone.",
    q1:"The metal",  q1b:"Platinum is priced with 14K.",
    q2:"The piece",  q2b:"Chain, pendant, ring or earrings.",
    q3:"The style",  q3b:"How the stone sits in it.",
    q4:"Your center stone", q4b:"The size of the diamond going into it.",
    q5:"The back",   q5b:"How the earring closes. Neither costs more.",
    of:"of",
    from:"from",
    totalT:"Setting price",
    noStone:"Setting only. This price does not include a diamond.",
    noChain:"The chain only. No pendant, no stone.",
    noChainB:"Our cable chain, made in your metal. Add a pendant above and we will price the two together.",
    noStoneB:"Stones are bought on camera during our live, or brought to us. If you have not chosen one yet, say so when you write and we will put a tray in front of you.",
    cta:"Continue to checkout",
    ctaQuote:"Request this setting",
    ctaSub:"Secure checkout",
    pick:"Answer them all and the price appears here.",
    of3:"of 3",
    madeIn:"Made in New York City \u00b7 four to six weeks \u00b7 photographed before it ships",
    errPick:"Please finish every choice first.",
    busy:"Opening checkout\u2026",
    summaryT:"Your setting",
    included:["Built to order in your metal","Your stone set by our bench","Photographed before it ships","Insured shipping, fully tracked"],
    reset:"Start again",
    quoteOk:"Your setting is with us.",
    quoteBody:"We have the full specification and the price. Expect a reply within 24 hours with the drawing and how to pay."
  },

  /* ---------- careers ---------- */
  careers:{
    eyebrow:"At the table",
    h:"Small house.<br>Real <em>stones.</em>",
    body:"We are not a chain and we are not a start-up. We are a few people in New York City with a loupe, a bench and a camera, moving real stones to real customers every day. Nobody here does only one job.",
    what:"What we look for",
    points:[
      { t:"You can be trusted with the tray",   b:"Everything in this house is small, expensive and easy to lose. That is most of the interview." },
      { t:"You answer people",                  b:"A customer who writes at eleven at night gets an answer from a person, not a form." },
      { t:"You are not precious about the work", b:"Whoever sold the stone on camera also packs the box when the box needs packing." },
      { t:"You want to learn stones",           b:"Cut, color, clarity and carat can be taught, and we will teach them. Curiosity cannot." }
    ],
    rolesT:"Open now",
    roles:["Live Sales Host \u2014 English","Live Sales Host \u2014 Spanish",
           "Social Media & Content Producer","Logistics & Operations Coordinator",
           "Shipping & Fulfillment Associate","Open Application"],
    formT:"Send your resume",
    formB:"Tell us which role and one line about why. We read every application and reply within a week.",
    fName:"Your name", fEmail:"Email", fPhone:"Phone", fRole:"Role",
    fLinks:"Portfolio, LinkedIn or Instagram", fLinksHint:"Optional \u2014 a link tells us more than a paragraph",
    fNote:"Why this house", fNoteHint:"A few lines is plenty",
    fFile:"Resume", fFilePick:"Choose a file", fFileChosen:"Attached", fFileHint:"PDF, DOC or DOCX \u00b7 up to 8 MB",
    send:"Send application", sending:"Sending\u2026",
    okTitle:"Received.", okBody:"Your application is with us. We read every one and reply within a week.",
    errName:"Please add your name.", errEmail:"Please add an email we can reply to.",
    errResume:"Please attach a resume.", errFile:"That file is over 8 MB. Please send a smaller one.",
    privacy:"We use what you send only to consider you for work here. We do not share it, and we do not add you to a list."
  },

  /* ---------- the cabinet: finished pieces, in transit ---------- */
  cabinet:{
    eyebrow:"The cabinet",
    h:"Finished pieces.<br>Arriving <em>soon.</em>",
    soon:"In transit",
    body:"Rings, studs and pendants already set and ready to ship \u2014 no drawing, no bench time, no wait. The first shipment is on its way to New York. When it lands it goes here, each piece with its certificate and its price on the page.",
    cta:"Watch the live", ctaSub:"@the_ara_atelier",
    alt:"Commission one instead"
  },

  /* ---------- the journal ---------- */
  journal:{
    eyebrow:"The journal",
    h:"One commission<br>at a <em>time.</em>",
    body:"Every custom piece that leaves this bench gets written up: the stone the customer chose, what they asked for, the metal, and a photograph of the finished thing. It is the closest we can get to handing you the tray over the internet.",
    soon:"First entries being written",
    empty:"Nothing published yet. The first commissions of the season are being photographed now.",
    cta:"Start a commission",
    readMore:"Read"
  },

  hero:{
    eyebrow:"New York City · Laboratory-grown · IGI certified",
    l1:"Rare shapes.", l2:"Rare color.", l3:"Rare patience.",
    sub:"Three billion years, or fifty days. The stone cannot tell the difference — and neither can the laboratory that grades it.",
    cta1:"Customize your imagination", cta2:"See the selection"
  },

  badges:[
    { k:"IGI",  t:"IGI certified",           s:"Every stone, no exceptions" },
    { k:"39",   t:"Cuts in the book",        s:"Thirty-nine, and counting" },
    { k:"LAB",  t:"Laboratory-grown",        s:"Same carbon, shorter story" },
    { k:"NY",   t:"Live from the Big Apple", s:"Where the coffee is bad and the stones are not" }
  ],

  ticker:"Rare shapes · Rare color · Rare patience · IGI certified · Fancy color · Made to order · New York City · ",


  selection:{
    eyebrow:"The selection",
    h:"Thirty-nine cuts.<br>Nine <em>colors.</em>",
    body:"This is what sets us apart: almost any house will sell you a white round. We work in pentagon, kite, Dutch marquise, oval step — and we work them in color. Choose a color, choose a shape, and the whole tray changes.",
    fColor:"Color", fShape:"Shape",
    shapeAll:"All", shapeRound:"Round", shapeOval:"Oval", shapePear:"Pear & heart",
    shapeMarquise:"Marquise", shapeSquare:"Square & rectangle", shapeGeometric:"Geometric", shapeSide:"Half & side",
    house:"House shape", facets:"facets", count:"cuts shown",
    none:"No cut matches that combination. Clear a filter, or write to us and we will look for it.",
    note:"Availability changes weekly. If you are after a particular cut in a particular color, write to us and we will look for it."
  },

  upclose:{
    eyebrow:"Up close",
    h:"One color,<br>two <em>cuts.</em>",
    body:"The same blue reads differently depending on how the stone is faceted. A brilliant breaks the color into flashes and scatters it; an elongated cut holds it in longer, calmer planes. Neither is better. They are different arguments for the same hue — which is why it is worth a close look before deciding.",
    lede:"An intense pink out of the ground sells in Geneva. Out of a laboratory, it can be owned.",
    drag:"Drag to compare",
    left:"Brilliant · round", right:"Brilliant · Dutch marquise"
  },


  stone:{
    eyebrow:"The diamond",
    h:"A diamond,<br>made <em>on purpose.</em>",
    lede:"Same carbon. Same hardness. Same fire. The only difference is the biography.",
    body:"A laboratory-grown diamond crystallizes in weeks inside a chamber rather than over a billion years underground. Identical structure, identical optical properties, the same answer to light. A gemologist needs equipment to tell; by eye, no one can.\n\nThey are created two ways: HPHT, which reproduces the pressure and heat of the earth's mantle, and CVD, which deposits carbon layer by layer onto a seed. Your IGI report states which was used.",
    colLab:"Laboratory", colMine:"Mine",
    rows:[
      ["Composition","Carbon","Carbon"],
      ["Hardness","10 / 10","10 / 10"],
      ["Brilliance and fire","Identical","Identical"],
      ["Provenance","We know the exact day","It's a long story"],
      ["Conflict","Zero blood. Just carbon.","Depends who you ask"],
      ["Intense color","Pink, blue, green — genuinely attainable","International auction prices"],
      ["Rare cuts","Kite, pentagon, cadillac — no drama","Special order and patience"],
      ["For the same budget","More carat, better color, better clarity","Less of everything"],
      ["Wait time","A few weeks","≈ 1,000,000,000 years"]
    ],
    candor:"A note of candor: a laboratory-grown stone is not an investment instrument. Resale value is modest. You buy it because it is beautiful."
  },

  vocab:{
    eyebrow:"Vocabulary",
    h:"The four words<br>that set the <em>price.</em>",
    items:[
      { t:"Carat",   b:"Weight, not size. One carat is 0.20 grams. Two stones of equal weight can look different face-up: a deep cut hides its weight downward." },
      { t:"Color",   b:"Whites run D, colorless, to Z. Colored stones use another scale: Fancy Light, Fancy, Fancy Intense, Fancy Vivid, Fancy Deep. That is where we live." },
      { t:"Clarity", b:"From FL and IF, flawless, down through VVS, VS, SI to I. The report includes a plot showing where each internal mark sits." },
      { t:"Cut",     b:"The only one of the four made by a human hand. It governs brilliance — and, in a colored stone, how much color you see." }
    ]
  },

  cert:{
    eyebrow:"Certification",
    h:"Your IGI report,<br>line by <em>line.</em>",
    body:"The International Gemological Institute is one of the world's reference laboratories for laboratory-grown stones. Each of ours arrives with its own. It is worth knowing how to read one — not only ours, anyone's.",
    lines:[
      ["Report Number","The report's unique number. Use it to verify the stone at igi.org."],
      ["Laboratory Grown","This line must always appear. Without it, it is not a laboratory-grown report."],
      ["Growth Method","HPHT or CVD. How the stone was formed."],
      ["Shape and Cutting Style","The cut by its technical name — from round brilliant to kite, pentagon or Dutch marquise."],
      ["Color Grade","On a colored stone, the full fancy description: intensity, hue and tone. It is the line we read most closely."],
      ["Carat Weight","Exact weight, usually to two decimals."],
      ["Measurements","Millimeters. This is what actually tells you the face-up size."],
      ["Clarity Grade","FL through I3, accompanied by the clarity plot."],
      ["Cut · Polish · Symmetry","Cut, polish and symmetry quality. The cut grade applies only to rounds."],
      ["Fluorescence","Its reaction under ultraviolet light. None, Faint, Medium, Strong."],
      ["Laser Inscription","Many stones carry the number inscribed on the girdle. Read it with a 10× loupe."],
      ["Comments","Laboratory notes. Always worth reading."]
    ],
    habit:"At igi.org, under Report Check, enter the number and the report appears. It can be done during the live, before deciding. We consider it the healthiest habit in the trade."
  },

  record:{
    eyebrow:"The house",
    h:"Why <em>Ara?</em>",
    body:"Because the stone is shown before it is sold, the paper is on screen before the bidding, and the unusual cut you have been looking for is probably already in the tray. We are a small house. That is the point.",
    title:"Stone record", tag:"Example",
    rows:[
      ["Type","Laboratory-grown diamond"],
      ["Method","CVD"],
      ["Cut","Kite"],
      ["Weight","1.28 ct"],
      ["Color","Fancy Intense Pink"],
      ["Clarity","VS1"],
      ["Polish / Symmetry","Excellent / Excellent"],
      ["Measurements","9.14 × 6.02 × 3.41 mm"],
      ["Fluorescence","None"],
      ["Report","IGI · LG······"]
    ],
    note:"Sample record — this is how every stone is presented on the live."
  },

  days:{
    eyebrow:"The making",
    h:"Fifty days, and<br>not one <em>shortcut.</em>",
    body:"People assume a grown diamond is quick. It is not. It is patient in a different place — and for most of those weeks, a person is watching it. A wafer of seed diamond sits in a methane-hydrogen plasma at 900–1,200 °C while carbon settles onto it one atomic layer at a time. Every few days the plate comes out, is re-polished by hand, and goes back in.",
    caption:"One three-carat fancy shape, stage by stage",
    colStage:"Stage", colDays:"Days",
    stages:[
      ["Seed preparation and reactor load","1"],
      ["Growth in the reactor","21–28"],
      ["Separation, mapping and marking","3"],
      ["Sawing, bruting and blocking","3"],
      ["Brillianteering and final polish","4–6"],
      ["IGI certification","15"]
    ],
    total:"From seed to certificate", totalV:"47–56",
    barTitle:"Where the days go — 49.5 days, typical",
    keyGrowth:"Growth", keyCutting:"Cutting", keyIgi:"IGI",
    hoursLabel:"Hours of skilled human attention",
    hoursBody:"Roughly 80 of them are a cutter's hands on a cast-iron scaife charged with diamond dust. Nothing leaves us uncertified — every stone goes to the IGI, and we do not chase that fifteen days down.",
    pull:"You are not paying for scarcity.", pull2:"You are paying for the days."
  },

  bespoke:{
    eyebrow:"Made to order",
    h:"Build the piece<br>you have <em>in mind.</em>",
    body:"Send a sketch on the back of an envelope, a screenshot, or a photograph of something you saw in a window. We will build it. There is no catalog to choose from, because there is no catalog. Every Ara piece is made once, for one person, by bench jewelers who came up through the trade.",
    offers:[
      ["Any design. Any stone.","Solitaire, three-stone, halo, bezel, toi-et-moi, or something nobody has made yet."],
      ["Solid gold.","Yellow, white or rose — solid all the way through. Never plated, never filled, never hollow."],
      ["Hand-finished at the bench.","Seats cut under magnification, galleries finished on the inside where only you will ever see them."],
      ["Your stone, or ours.","We will gladly set a diamond you already own, inherited or bought elsewhere."]
    ],
    chainTitle:"Six steps, start to finish",
    chainHint:"Select a step",
    chain:[
      { t:"Talk", b:"A conversation, not a form. What the piece is for, who wears it, what they already own, what you would rather avoid. Ten minutes here saves three weeks later." },
      { t:"Sketch", b:"A hand drawing, sent to you the same week. Proportions, the stone's seat, the shoulder width. Change anything. Nothing is committed until you like the drawing." },
      { t:"CAD", b:"The sketch becomes a precise 3D model, rendered from the angles you will actually see. This is where millimeters get decided — band width, gallery height, how high the stone sits." },
      { t:"Wax", b:"The model is printed and cast. A physical object you could hold, if you were in the room. We photograph it against a hand for scale before anything is poured in gold." },
      { t:"Bench", b:"A jeweler cuts the seats under magnification, sets the stone, and finishes the gallery on the inside — the part only the wearer ever sees. This is the slow part, and it should be." },
      { t:"Check", b:"Final inspection under 10× magnification and two lighting conditions. More pieces go back to the bench here than most houses would tolerate. Then it is boxed, insured and sent." }
    ]
  },

  commission:{
    eyebrow:"Customization",
    h:"Customize your<br><em>imagination.</em>",
    body:"Send the details and a picture of what you want — a screenshot, a sketch, a photograph from a window. Our team reviews every request by hand and comes back with a quote.",
    fName:"Full name", fEmail:"Email", fPhone:"Phone or WhatsApp",
    fTikTok:"TikTok username", fTikTokHint:"If you bought from our live",
    fStone:"Which diamond", fStoneHint:"Cut, color, carat, or the IGI report number",
    fPiece:"What you would like made", fPieceOpts:["Ring","Pendant","Earrings","Bracelet","Not sure yet","Something else"],
    fDetails:"Tell us about the piece",
    fDetailsHint:"Metal color, finger size, occasion, budget range — anything that helps",
    fFile:"Attach a picture", fFileHint:"A screenshot, a sketch or a photo. Optional but it helps.",
    fFileChosen:"Attached",
    submit:"Send inquiry", sending:"Sending…",
    required:"Please fill in your name, email and what you would like made.",
    okTitle:"Thank you.",
    okBody:"Our team will reach out within the next 24 hours with a quote.",
    okNote:"A copy has been sent to info@thearaatelier.com.",
    mailNote:"Your email program has opened with everything filled in. Attach your picture and press send.",
    close:"Close",
    quoted:"Every commission is quoted individually. Mounting prices depend on the design, the metal and the stone you are setting."
  },

  live:{
    eyebrow:"On camera",
    h:"Loose stones,<br>real <em>people.</em>",
    body:"We sell the loose stone. What you do with it afterwards — a solitaire, a pendant, an anniversary ring, a gift that looks like nobody else's — is the enjoyable part.",
    soon:"Live now, most nights",
    soonBody:"The tray goes on camera on TikTok. Stones are shown one at a time \u2014 certificate, measurements, color under two lights \u2014 and sold in the room.",
    cta:"Watch on TikTok",
    ctaSub:"@the_ara_atelier",
  },


  /* the band on the home page — the emotional turn before the technical grid */
  wornband:{
    eyebrow:"Worn",
    h:"The stone is the beginning.<br><em>Not the end.</em>",
    body:"We sell the loose stone. What it becomes, and whose hand it ends up on, is the part we like watching.",
    cta:"See them worn"
  },

  /* the lookbook */
  worn:{
    eyebrow:"Worn",
    h:"Our stones. Our bench.<br><em>Their hands.</em>",
    body:"Every piece here started as a loose stone on a velvet tray, picked by somebody who knew exactly which one they wanted. Then our bench set it.",
    note:"Made to order. No two the same. Tell us what you have in mind and we will draw it first.",
    cta:"Start a commission"
  },

  /* the doorways — one card per part of the house */
  pages:{
    eyebrow:"The house",
    h:"Six rooms.<br>One <em>table.</em>",
    items:[
      { k:"book",    t:"The Book",      s:"Thirty-nine cuts",       b:"Kite, Dutch marquise, old mine, star. Filter by color and by shape.", img:"trade-01-marquise-tweezers", href:"#selection" },
      { k:"vault",   t:"The Vault",     s:"What is in the tray",    b:"Stones with their carat, their color and their IGI number.",         img:"trade-04-desk",              href:"#vault" },
      { k:"diamond", t:"The Diamond",   s:"Same carbon, shorter story", b:"Fifty days from seed to certificate, explained without the sales pitch.", img:"stone-hero-pink-lozenge", href:"#stone" },
      { k:"order",   t:"Made to Order", s:"Build the piece",        b:"Six steps from a conversation to a finished ring.",                   img:"ring-05-backlit",            href:"#bespoke" },
      { k:"worn",    t:"Worn",          s:"On the hand",            b:"What the stones become once somebody chooses one.",                   img:"earring-03-pear-drop",       href:"#worn" },
      { k:"house",   t:"The House",     s:"Where the shop buys",    b:"A tray, a loupe, and a table in New York City.",                      img:"trade-05-handover",          href:"#ethics" }
    ]
  },

  vault:{
    eyebrow:"The vault",
    h:"Loose stones,<br>ready to <em>set.</em>",
    soon:"Sold live for now",
    body:"The online vault is being built. Until it opens, everything we have is shown on TikTok \u2014 every stone with its IGI report number, its measurements and its color under two lights. If you are after a particular cut or color, tell us and we will look for it.",
    cta:"See what is in the tray",
    ctaSub:"@the_ara_atelier",
    alt:"Ask for a specific stone"
  },

  ethics:{
    eyebrow:"Why it matters",
    h:"A diamond with<br>nothing <em>behind it.</em>",
    body:"Every mined carat carries a history you cannot see. A grown diamond carries one you can read — no pit opened, no riverbed diverted, no ore body displaced, no tailings dam left for the next century to manage.",
    items:[
      ["No conflict. Ever.","Grown in a sealed reactor under one roof. No mine, no militia, no chain of custody to take on faith."],
      ["No ground broken.","No pit, no overburden, no tailings, no rehabilitation debt left to a community."],
      ["Water stays where it is.","No river diverted, no silt, no processing slurry to settle out afterwards."],
      ["A footprint that can improve.","Energy is the only real input, and energy can be made cleanly. A mine cannot be un-dug."]
    ],
    claim:"We do not claim every laboratory diamond is green. We claim ours can tell you exactly where it came from — and that no part of it was taken from anyone."
  },

  faq:{
    eyebrow:"Questions",
    h:"Asked and <em>answered.</em>",
    items:[
      ["Is a laboratory-grown diamond a real diamond?",
       "Yes. Same carbon lattice, same 10 on the Mohs scale, same brilliance and fire. It is not moissanite and not cubic zirconia — those are different materials that imitate diamond. A laboratory diamond IS diamond; the only difference is where it crystallized."],
      ["Will anyone be able to tell?",
       "Not by eye, and not with a loupe. A gemologist needs specialist equipment. Your IGI report states plainly that the stone is laboratory-grown, and many stones carry the report number inscribed on the girdle."],
      ["What does an IGI certificate actually guarantee?",
       "It records what the laboratory measured: growth method, shape, carat, color grade, clarity, measurements, polish, symmetry and fluorescence. You can verify any report yourself at igi.org under Report Check, using the report number — during the live, before you decide."],
      ["Do you sell finished jewelry?",
       "We sell the loose stone. Mountings are made to order at the bench — ring, pendant, earrings or bracelet — and we will gladly set a diamond you already own. Start with the commission form on this page."],
      ["How much does a mounting cost?",
       "Every commission is quoted individually, because the price depends on the design, the metal weight and the stone being set. Send the commission form and our team comes back with a quote within 24 hours."],
      ["How long does a bespoke piece take?",
       "Talk, sketch, CAD, wax, bench, check. Typically three to five weeks from approved CAD, depending on the design and whether the stone is in the tray or still growing."],
      ["Is a laboratory diamond a good investment?",
       "No, and we would rather say so. Resale value is modest, and prices in the category have fallen for years. Buy it because it is beautiful and because it is the color and cut you wanted — not as an asset."],
      ["What happens if the stone arrives damaged or not as described?",
       "It is put right without discussion. What appears on screen is what arrives in the box; that is the whole point of showing the certificate first."],
      ["Do you ship outside the United States?",
       "Yes, insured and tracked. Duties and import taxes are the buyer's responsibility and vary by country — write to us before bidding and we will tell you what to expect."],
      ["Can I request a cut you do not have?",
       "Often, yes. Availability changes weekly and we can commission a shape. Tell us the cut, the color and the carat you have in mind and we will tell you honestly whether it is realistic."],
      ["Do you speak Spanish?",
       "Sí. The live, the website and the paperwork are all available in Spanish."],
      ["How do I reach a real person?",
       "Ask Pamela for a representative and she will take your details, or write to info@thearaatelier.com. Our team replies within 24 hours, every day."]
    ]
  },

  contact:{
    eyebrow:"Contact",
    h:"Write to <em>us.</em>",
    email:"Email", tiktok:"TikTok", hours:"Hours", hoursV:"Every day",
    replies:"Replies", repliesV:"Within 24 hours",
    cityLine:"The Ara Atelier · New York City",
    blurb:"Laboratory-grown diamonds in rare shapes and rare colors. Every stone IGI certified, every mounting made to order, every piece made once."
  },

  legal:{
    terms:"Terms & Conditions", privacy:"Privacy Policy", shipping:"Shipping & Returns",
    back:"Back to the atelier", updated:"Last updated",
    disclaimer:"All diamonds sold by The Ara Atelier are laboratory-grown and are accompanied by an IGI report. Laboratory-grown diamonds are chemically, physically and optically identical to mined diamonds. Prices are quoted in US dollars; stones and mountings are quoted separately and individually. Screen color varies by device — the IGI report is the definitive description of any stone. Laboratory-grown diamonds are not sold as investments and resale value is modest. Availability changes weekly."
  },

  footer:{ rights:"All rights reserved", line:"Lab-grown · IGI certified · Made to order" },

  pam:{
    title:"Pamela", role:"Atelier concierge",
    hello:"Good evening — I am Pamela, from the atelier.\n\nAsk me about a shape, a color, what fifty days in the reactor actually buys you, or what it would cost to set a stone you already own. If you would rather speak to someone on the team, just say so.",
    chips:["What is a Dutch marquise?","Lab-grown or mined?","Set a stone I already own","Talk to a representative"],
    ph:"Ask about a stone, a shape, a price…",
    offline:"Write to info@thearaatelier.com",
    noReach:"I cannot reach the atelier's line from this view. Write to info@thearaatelier.com and the team will answer within 24 hours.",
    notGranted:"I would need your permission to answer from here. info@thearaatelier.com reaches the bench directly.",
    rateLimited:"One moment — too many questions at once. Try me again shortly.",
    generic:"Something went wrong on my side. info@thearaatelier.com reaches the bench directly.",
    connecting:"Connecting…",
    leadOk:"Thank you — I have passed your details to the team. Someone will reach out within the next 24 hours.",
    openForm:"Open the commission form"
  },

  seo:{
    title:"The Ara Atelier — Lab-Grown Fancy Color Diamonds, New York",
    desc:"Thirty-nine diamond cuts in nine fancy colors, every stone IGI certified and laser inscribed. Kite, pentagon, Dutch marquise and oval step, made to order in New York City."
  }
},

/* ------------------------------------------------------------------ ES */
es: {
  code:"es",
  nav:{ home:"Inicio", book:"El Libro", diamond:"El Diamante", custom:"Hecho a Medida",
        worn:"Llevado", vault:"La B\u00f3veda", journal:"Diario", house:"La Casa",
        careers:"Empleo", contact:"Contacto" },

  heads:{
    book:    { h:"El Libro",        lede:"Treinta y nueve tallas, todas fotografiadas sobre negro. Elija un color y el libro entero cambia." },
    diamond: { h:"El Diamante",     lede:"Mismo carbono. Misma dureza. Mismo certificado. Una historia m\u00e1s corta, y nadie tuvo que excavar." },
    custom:  { h:"Hecho a Medida",  lede:"Usted elige la piedra. Nosotros dibujamos el engaste, usted aprueba el dibujo y nuestro taller lo construye." },
    worn:    { h:"Llevado",         lede:"En qu\u00e9 se convierten las piedras cuando alguien elige una." },
    vault:   { h:"La B\u00f3veda",     lede:"Piedras sueltas listas para engastar \u2014 y las piezas terminadas que llegan a El Gabinete." },
    house:   { h:"La Casa",         lede:"Una bandeja, una lupa y una mesa en Nueva York." },
    careers: { h:"Empleo",          lede:"Casa peque\u00f1a, jornadas largas, piedras de verdad. Si eso suena a invitaci\u00f3n y no a advertencia, env\u00edenos su curr\u00edculum." },
    journal: { h:"El Diario",       lede:"Cada encargo, contado: la piedra, el pedido, el metal y lo que sali\u00f3 del taller." },
    contact: { h:"Contacto",        lede:"Escr\u00edbanos. Respondemos cada mensaje en 24 horas, en espa\u00f1ol o en ingl\u00e9s." }
  },

  config:{
    eyebrow:"El engaste",
    h:"Calcule su <em>montura.</em>",
    body:"Unas pocas preguntas \u2014 cu\u00e1ntas depende de lo que est\u00e9 haciendo. El precio aparece mientras las responde, y es el precio real: la misma tabla que usamos por tel\u00e9fono.",
    q1:"El metal",  q1b:"El platino se cotiza igual que el 14K.",
    q2:"La pieza",  q2b:"Cadena, colgante, anillo o aretes.",
    q3:"El estilo", q3b:"C\u00f3mo se asienta la piedra.",
    q4:"Su piedra central", q4b:"El tama\u00f1o del diamante que va dentro.",
    q5:"El cierre", q5b:"C\u00f3mo cierra el arete. Ninguno cuesta m\u00e1s.",
    of:"de",
    from:"desde",
    totalT:"Precio del engaste",
    noStone:"Solo el engaste. Este precio no incluye el diamante.",
    noChain:"Solo la cadena. Sin colgante, sin piedra.",
    noChainB:"Nuestra cadena de cable, en su metal. A\u00f1ada un colgante arriba y cotizamos las dos juntas.",
    noStoneB:"Las piedras se compran en c\u00e1mara durante nuestro live, o usted trae la suya. Si a\u00fan no ha elegido una, d\u00edganoslo al escribir y le ponemos una bandeja delante.",
    cta:"Continuar al pago",
    ctaQuote:"Solicitar este engaste",
    ctaSub:"Pago seguro",
    pick:"Resp\u00f3ndalas todas y el precio aparece aqu\u00ed.",
    of3:"de 3",
    madeIn:"Hecho en Nueva York \u00b7 de cuatro a seis semanas \u00b7 fotografiado antes de enviarse",
    errPick:"Complete todas las elecciones primero.",
    busy:"Abriendo el pago\u2026",
    summaryT:"Su engaste",
    included:["Fabricado a medida en su metal","Su piedra engastada por nuestro taller","Fotografiado antes de enviarse","Env\u00edo asegurado y con seguimiento"],
    reset:"Empezar de nuevo",
    quoteOk:"Tenemos su engaste.",
    quoteBody:"Tenemos la especificaci\u00f3n completa y el precio. Espere respuesta en 24 horas con el dibujo y la forma de pago."
  },

  careers:{
    eyebrow:"En la mesa",
    h:"Casa peque\u00f1a.<br>Piedras <em>de verdad.</em>",
    body:"No somos una cadena y no somos una start-up. Somos unas pocas personas en Nueva York con una lupa, un taller y una c\u00e1mara, moviendo piedras reales a clientes reales todos los d\u00edas. Aqu\u00ed nadie hace un solo trabajo.",
    what:"Lo que buscamos",
    points:[
      { t:"Se le puede confiar la bandeja",  b:"Todo en esta casa es peque\u00f1o, caro y f\u00e1cil de perder. Esa es casi toda la entrevista." },
      { t:"Usted contesta",                  b:"Un cliente que escribe a las once de la noche recibe respuesta de una persona, no de un formulario." },
      { t:"No le da reparo el trabajo",      b:"Quien vendi\u00f3 la piedra en c\u00e1mara tambi\u00e9n empaca la caja cuando hay que empacarla." },
      { t:"Quiere aprender de piedras",      b:"Talla, color, pureza y quilates se ense\u00f1an, y se los ense\u00f1amos. La curiosidad no." }
    ],
    rolesT:"Abierto ahora",
    roles:["Presentador de Ventas en Vivo \u2014 ingl\u00e9s","Presentador de Ventas en Vivo \u2014 espa\u00f1ol",
           "Productor de Contenido y Redes Sociales","Coordinador de Log\u00edstica y Operaciones",
           "Auxiliar de Env\u00edos y Preparaci\u00f3n de Pedidos","Candidatura Abierta"],
    formT:"Env\u00ede su curr\u00edculum",
    formB:"D\u00edganos a qu\u00e9 puesto y una l\u00ednea sobre por qu\u00e9. Leemos todas las candidaturas y respondemos en una semana.",
    fName:"Su nombre", fEmail:"Correo", fPhone:"Tel\u00e9fono", fRole:"Puesto",
    fLinks:"Portafolio, LinkedIn o Instagram", fLinksHint:"Opcional \u2014 un enlace dice m\u00e1s que un p\u00e1rrafo",
    fNote:"Por qu\u00e9 esta casa", fNoteHint:"Unas l\u00edneas bastan",
    fFile:"Curr\u00edculum", fFilePick:"Elegir archivo", fFileChosen:"Adjuntado", fFileHint:"PDF, DOC o DOCX \u00b7 hasta 8 MB",
    send:"Enviar candidatura", sending:"Enviando\u2026",
    okTitle:"Recibido.", okBody:"Su candidatura est\u00e1 con nosotros. Leemos todas y respondemos en una semana.",
    errName:"A\u00f1ada su nombre.", errEmail:"A\u00f1ada un correo para responderle.",
    errResume:"Adjunte un curr\u00edculum.", errFile:"Ese archivo supera 8 MB. Env\u00ede uno m\u00e1s peque\u00f1o.",
    privacy:"Usamos lo que env\u00eda solo para considerarlo para un puesto aqu\u00ed. No lo compartimos ni lo a\u00f1adimos a ninguna lista."
  },

  cabinet:{
    eyebrow:"El gabinete",
    h:"Piezas terminadas.<br>Llegan <em>pronto.</em>",
    soon:"En camino",
    body:"Anillos, broqueles y colgantes ya engastados y listos para enviar \u2014 sin dibujo, sin taller, sin espera. El primer env\u00edo va camino de Nueva York. Cuando llegue aparece aqu\u00ed, cada pieza con su certificado y su precio en la p\u00e1gina.",
    cta:"Ver el live", ctaSub:"@the_ara_atelier",
    alt:"Encargar una a medida"
  },

  journal:{
    eyebrow:"El diario",
    h:"Un encargo<br>a la <em>vez.</em>",
    body:"Cada pieza a medida que sale de este taller se cuenta aqu\u00ed: la piedra que eligi\u00f3 el cliente, lo que pidi\u00f3, el metal y una fotograf\u00eda de la pieza terminada. Es lo m\u00e1s cerca que podemos estar de pasarle la bandeja por internet.",
    soon:"Primeras entradas en camino",
    empty:"A\u00fan no hay nada publicado. Los primeros encargos de la temporada se est\u00e1n fotografiando ahora.",
    cta:"Empezar un encargo",
    readMore:"Leer"
  },

  hero:{
    eyebrow:"Nueva York · Cultivado en laboratorio · Certificado IGI",
    l1:"Formas raras.", l2:"Color raro.", l3:"Paciencia rara.",
    sub:"Tres mil millones de años, o cincuenta días. La piedra no nota la diferencia — y el laboratorio que la califica, tampoco.",
    cta1:"Personalice su imaginación", cta2:"Ver la selección"
  },

  badges:[
    { k:"IGI",  t:"Certificado IGI",          s:"Cada piedra, sin excepción" },
    { k:"39",   t:"Tallas en el libro",       s:"Treinta y nueve, y subiendo" },
    { k:"LAB",  t:"Cultivado en laboratorio", s:"Mismo carbono, historia más corta" },
    { k:"NY",   t:"En vivo desde Nueva York", s:"Donde el café es malo y las piedras no" }
  ],

  ticker:"Formas raras · Color raro · Paciencia rara · Certificado IGI · Color fancy · Hecho a medida · Nueva York · ",


  selection:{
    eyebrow:"La selección",
    h:"Treinta y nueve tallas.<br>Nueve <em>colores.</em>",
    body:"Esto es lo que nos distingue: casi cualquier casa le vende un redondo blanco. Nosotros trabajamos el pentágono, la cometa, la marquesa holandesa, el oval escalonado — y los trabajamos en color. Elija un color, elija una forma, y la bandeja entera cambia.",
    fColor:"Color", fShape:"Forma",
    shapeAll:"Todas", shapeRound:"Redonda", shapeOval:"Oval", shapePear:"Pera y corazón",
    shapeMarquise:"Marquesa", shapeSquare:"Cuadrada y rectangular", shapeGeometric:"Geométrica", shapeSide:"Media y laterales",
    house:"Forma de la casa", facets:"facetas", count:"tallas mostradas",
    none:"Ninguna talla coincide con esa combinación. Quite un filtro, o escríbanos y la buscamos.",
    note:"La disponibilidad cambia cada semana. Si busca una talla concreta en un color concreto, escríbanos y la buscamos."
  },

  upclose:{
    eyebrow:"De cerca",
    h:"Un color,<br>dos <em>tallas.</em>",
    body:"El mismo azul se lee de forma distinta según cómo esté facetada la piedra. Un brillante rompe el color en destellos y lo dispersa; una talla alargada lo sostiene en planos más largos y tranquilos. Ninguna es mejor. Son dos argumentos distintos para el mismo tono — por eso conviene mirarlo de cerca antes de decidir.",
    lede:"Un rosa intenso salido de la tierra se vende en Ginebra. Salido de un laboratorio, se puede tener.",
    drag:"Arrastre para comparar",
    left:"Brillante · redondo", right:"Brillante · marquesa holandesa"
  },


  stone:{
    eyebrow:"El diamante",
    h:"Un diamante,<br>hecho <em>a propósito.</em>",
    lede:"Mismo carbono. Misma dureza. Mismo fuego. La única diferencia es la biografía.",
    body:"Un diamante de laboratorio cristaliza en semanas dentro de una cámara, en vez de durante mil millones de años bajo tierra. Estructura idéntica, propiedades ópticas idénticas, la misma respuesta a la luz. Un gemólogo necesita equipo para distinguirlo; a simple vista, nadie puede.\n\nSe crean de dos maneras: HPHT, que reproduce la presión y el calor del manto terrestre, y CVD, que deposita carbono capa por capa sobre una semilla. Su informe IGI indica cuál se usó.",
    colLab:"Laboratorio", colMine:"Mina",
    rows:[
      ["Composición","Carbono","Carbono"],
      ["Dureza","10 / 10","10 / 10"],
      ["Brillo y fuego","Idénticos","Idénticos"],
      ["Procedencia","Sabemos el día exacto","Es una larga historia"],
      ["Conflicto","Cero sangre. Solo carbono.","Depende de a quién pregunte"],
      ["Color intenso","Rosa, azul, verde — realmente alcanzable","Precios de subasta internacional"],
      ["Tallas raras","Cometa, pentágono, cadillac — sin drama","Pedido especial y paciencia"],
      ["Con el mismo presupuesto","Más quilates, mejor color, mejor pureza","Menos de todo"],
      ["Tiempo de espera","Unas semanas","≈ 1.000.000.000 de años"]
    ],
    candor:"Una nota de franqueza: una piedra de laboratorio no es un instrumento de inversión. El valor de reventa es modesto. Se compra porque es hermosa."
  },

  vocab:{
    eyebrow:"Vocabulario",
    h:"Las cuatro palabras<br>que fijan el <em>precio.</em>",
    items:[
      { t:"Quilate", b:"Peso, no tamaño. Un quilate son 0,20 gramos. Dos piedras del mismo peso pueden verse distintas de frente: una talla profunda esconde el peso hacia abajo." },
      { t:"Color",   b:"Los blancos van de D, incoloro, hasta Z. Las piedras de color usan otra escala: Fancy Light, Fancy, Fancy Intense, Fancy Vivid, Fancy Deep. Ahí es donde vivimos." },
      { t:"Pureza",  b:"Desde FL e IF, impecable, pasando por VVS, VS, SI hasta I. El informe incluye un diagrama con la posición de cada marca interna." },
      { t:"Talla",   b:"La única de las cuatro hecha por mano humana. Gobierna el brillo — y, en una piedra de color, cuánto color se ve." }
    ]
  },

  cert:{
    eyebrow:"Certificación",
    h:"Su informe IGI,<br>línea por <em>línea.</em>",
    body:"El International Gemological Institute es uno de los laboratorios de referencia del mundo para piedras de laboratorio. Cada una de las nuestras llega con el suyo. Conviene saber leerlo — no solo el nuestro, el de cualquiera.",
    lines:[
      ["Report Number","El número único del informe. Úselo para verificar la piedra en igi.org."],
      ["Laboratory Grown","Esta línea siempre debe aparecer. Sin ella, no es un informe de piedra de laboratorio."],
      ["Growth Method","HPHT o CVD. Cómo se formó la piedra."],
      ["Shape and Cutting Style","La talla por su nombre técnico — del redondo brillante a la cometa, el pentágono o la marquesa holandesa."],
      ["Color Grade","En una piedra de color, la descripción fancy completa: intensidad, tono y saturación. Es la línea que leemos con más atención."],
      ["Carat Weight","Peso exacto, normalmente con dos decimales."],
      ["Measurements","Milímetros. Esto es lo que de verdad le dice el tamaño de frente."],
      ["Clarity Grade","De FL a I3, acompañado del diagrama de pureza."],
      ["Cut · Polish · Symmetry","Calidad de talla, pulido y simetría. El grado de talla solo aplica a redondos."],
      ["Fluorescence","Su reacción bajo luz ultravioleta. None, Faint, Medium, Strong."],
      ["Laser Inscription","Muchas piedras llevan el número grabado en el cinturón. Léalo con una lupa de 10×."],
      ["Comments","Notas del laboratorio. Siempre vale la pena leerlas."]
    ],
    habit:"En igi.org, en Report Check, escriba el número y aparece el informe. Se puede hacer durante el vivo, antes de decidir. Lo consideramos el hábito más sano del oficio."
  },

  record:{
    eyebrow:"La casa",
    h:"¿Por qué <em>Ara?</em>",
    body:"Porque la piedra se muestra antes de venderse, el papel está en pantalla antes de la puja, y esa talla inusual que lleva buscando probablemente ya está en la bandeja. Somos una casa pequeña. Ese es justamente el punto.",
    title:"Ficha de la piedra", tag:"Ejemplo",
    rows:[
      ["Tipo","Diamante cultivado en laboratorio"],
      ["Método","CVD"],
      ["Talla","Cometa"],
      ["Peso","1,28 ct"],
      ["Color","Fancy Intense Pink"],
      ["Pureza","VS1"],
      ["Pulido / Simetría","Excellent / Excellent"],
      ["Medidas","9,14 × 6,02 × 3,41 mm"],
      ["Fluorescencia","None"],
      ["Informe","IGI · LG······"]
    ],
    note:"Ficha de ejemplo — así se presenta cada piedra en el vivo."
  },

  days:{
    eyebrow:"La creación",
    h:"Cincuenta días, y<br>ni un solo <em>atajo.</em>",
    body:"La gente supone que un diamante cultivado es rápido. No lo es. Es paciente en otro lugar — y durante la mayor parte de esas semanas, alguien lo está vigilando. Una oblea de diamante semilla reposa en un plasma de metano e hidrógeno a 900–1.200 °C mientras el carbono se deposita capa atómica a capa atómica. Cada pocos días la placa sale, se repule a mano y vuelve a entrar.",
    caption:"Una forma fantasía de tres quilates, etapa por etapa",
    colStage:"Etapa", colDays:"Días",
    stages:[
      ["Preparación de la semilla y carga del reactor","1"],
      ["Crecimiento en el reactor","21–28"],
      ["Separación, mapeo y marcado","3"],
      ["Aserrado, bruteado y bloqueo","3"],
      ["Facetado y pulido final","4–6"],
      ["Certificación IGI","15"]
    ],
    total:"De la semilla al certificado", totalV:"47–56",
    barTitle:"Dónde van los días — 49,5 días, típico",
    keyGrowth:"Crecimiento", keyCutting:"Tallado", keyIgi:"IGI",
    hoursLabel:"Horas de atención humana experta",
    hoursBody:"Unas 80 son las manos de un tallador sobre una rueda de hierro fundido cargada con polvo de diamante. Nada sale de aquí sin certificar — cada piedra va al IGI, y no intentamos recortar esos quince días.",
    pull:"No está pagando por escasez.", pull2:"Está pagando por los días."
  },

  bespoke:{
    eyebrow:"Hecho a medida",
    h:"Cree la pieza<br>que tiene <em>en mente.</em>",
    body:"Mándenos un boceto en el reverso de un sobre, una captura de pantalla, o la foto de algo que vio en un escaparate. Lo construimos. No hay catálogo del que elegir, porque no hay catálogo. Cada pieza Ara se hace una sola vez, para una sola persona, por joyeros de banco formados en el oficio.",
    offers:[
      ["Cualquier diseño. Cualquier piedra.","Solitario, tres piedras, halo, bisel, toi-et-moi, o algo que nadie ha hecho todavía."],
      ["Oro sólido.","Amarillo, blanco o rosa — sólido de lado a lado. Nunca bañado, nunca relleno, nunca hueco."],
      ["Terminado a mano en el banco.","Asientos tallados bajo aumento, galerías rematadas por dentro donde solo usted las verá."],
      ["Su piedra, o la nuestra.","Con mucho gusto engastamos un diamante que ya tenga, heredado o comprado en otro sitio."]
    ],
    chainTitle:"Seis pasos, de principio a fin",
    chainHint:"Elija un paso",
    chain:[
      { t:"Hablar", b:"Una conversación, no un formulario. Para qué es la pieza, quién la lleva, qué tiene ya, qué preferiría evitar. Diez minutos aquí ahorran tres semanas después." },
      { t:"Boceto", b:"Un dibujo a mano, enviado la misma semana. Proporciones, el asiento de la piedra, el ancho de los hombros. Cambie lo que quiera. Nada se compromete hasta que le guste el dibujo." },
      { t:"CAD", b:"El boceto se convierte en un modelo 3D preciso, renderizado desde los ángulos que realmente verá. Aquí se deciden los milímetros: ancho del aro, altura de la galería, cuánto sobresale la piedra." },
      { t:"Cera", b:"El modelo se imprime y se funde. Un objeto físico que podría sostener, si estuviera en la sala. Lo fotografiamos junto a una mano, a escala, antes de verter nada en oro." },
      { t:"Banco", b:"Un joyero talla los asientos bajo aumento, engasta la piedra y remata la galería por dentro — la parte que solo ve quien la lleva. Esta es la parte lenta, y debe serlo." },
      { t:"Revisión", b:"Inspección final con aumento de 10× y dos condiciones de luz. Aquí vuelven al banco más piezas de las que la mayoría de las casas toleraría. Después se guarda, se asegura y se envía." }
    ]
  },

  commission:{
    eyebrow:"Personalización",
    h:"Personalice su<br><em>imaginación.</em>",
    body:"Envíenos los datos y una imagen de lo que quiere — una captura, un boceto, la foto de un escaparate. Nuestro equipo revisa cada solicitud a mano y responde con un presupuesto.",
    fName:"Nombre completo", fEmail:"Correo", fPhone:"Teléfono o WhatsApp",
    fTikTok:"Usuario de TikTok", fTikTokHint:"Si compró en nuestro vivo",
    fStone:"Qué diamante", fStoneHint:"Talla, color, quilates o el número de informe IGI",
    fPiece:"Qué desea que hagamos", fPieceOpts:["Anillo","Colgante","Pendientes","Pulsera","Aún no lo sé","Otra cosa"],
    fDetails:"Cuéntenos sobre la pieza",
    fDetailsHint:"Color del metal, talla de dedo, ocasión, presupuesto aproximado — todo lo que ayude",
    fFile:"Adjunte una imagen", fFileHint:"Una captura, un boceto o una foto. Opcional, pero ayuda.",
    fFileChosen:"Adjuntado",
    submit:"Enviar solicitud", sending:"Enviando…",
    required:"Por favor complete su nombre, correo y qué desea que hagamos.",
    okTitle:"Gracias.",
    okBody:"Nuestro equipo se pondrá en contacto en las próximas 24 horas con un presupuesto.",
    okNote:"Se ha enviado una copia a info@thearaatelier.com.",
    mailNote:"Su programa de correo se ha abierto con todo relleno. Adjunte su imagen y pulse enviar.",
    close:"Cerrar",
    quoted:"Cada encargo se presupuesta individualmente. El precio del montaje depende del diseño, del metal y de la piedra que se engasta."
  },

  live:{
    eyebrow:"Ante la cámara",
    h:"Piedras sueltas,<br>gente <em>de verdad.</em>",
    body:"Vendemos la piedra suelta. Lo que haga después con ella — un solitario, un colgante, un anillo de aniversario, un regalo que no se parece al de nadie — es la parte divertida.",
    soon:"En vivo, casi todas las noches",
    soonBody:"La bandeja sale ante la c\u00e1mara en TikTok. Las piedras se muestran una por una \u2014 certificado, medidas, color bajo dos luces \u2014 y se venden en la sala.",
    cta:"Ver en TikTok",
    ctaSub:"@the_ara_atelier",
  },


  wornband:{
    eyebrow:"Llevado",
    h:"La piedra es el principio.<br><em>No el final.</em>",
    body:"Vendemos la piedra suelta. En qu\u00e9 se convierte, y en qu\u00e9 mano termina, es la parte que nos gusta ver.",
    cta:"Verlas puestas"
  },

  worn:{
    eyebrow:"Llevado",
    h:"Nuestras piedras. Nuestro taller.<br><em>Sus manos.</em>",
    body:"Cada pieza aqu\u00ed empez\u00f3 como una piedra suelta en una bandeja de terciopelo, elegida por alguien que sab\u00eda exactamente cu\u00e1l quer\u00eda. Despu\u00e9s la engast\u00f3 nuestro taller.",
    note:"Hecho a medida. No hay dos iguales. D\u00edganos qu\u00e9 tiene en mente y lo dibujamos primero.",
    cta:"Empezar un encargo"
  },

  pages:{
    eyebrow:"La casa",
    h:"Seis salas.<br>Una <em>mesa.</em>",
    items:[
      { k:"book",    t:"El Libro",        s:"Treinta y nueve tallas",     b:"Cometa, marquesa holandesa, mina antigua, estrella. Filtre por color y por forma.", img:"trade-01-marquise-tweezers", href:"#selection" },
      { k:"vault",   t:"La B\u00f3veda",      s:"Lo que hay en la bandeja",   b:"Piedras con sus quilates, su color y su n\u00famero de informe IGI.",                   img:"trade-04-desk",              href:"#vault" },
      { k:"diamond", t:"El Diamante",     s:"Mismo carbono, historia m\u00e1s corta", b:"Cincuenta d\u00edas de la semilla al certificado, sin discurso de venta.",        img:"stone-hero-pink-lozenge",    href:"#stone" },
      { k:"order",   t:"Hecho a Medida",  s:"Construya la pieza",         b:"Seis pasos de una conversaci\u00f3n a un anillo terminado.",                          img:"ring-05-backlit",            href:"#bespoke" },
      { k:"worn",    t:"Llevado",         s:"En la mano",                 b:"En qu\u00e9 se convierten las piedras cuando alguien elige una.",                      img:"earring-03-pear-drop",       href:"#worn" },
      { k:"house",   t:"La Casa",         s:"Donde compra la tienda",     b:"Una bandeja, una lupa y una mesa en Nueva York.",                                img:"trade-05-handover",          href:"#ethics" }
    ]
  },

  vault:{
    eyebrow:"La bóveda",
    h:"Piedras sueltas,<br>listas para <em>engastar.</em>",
    soon:"Por ahora se vende en vivo",
    body:"La b\u00f3veda en l\u00ednea est\u00e1 en construcci\u00f3n. Hasta que abra, todo lo que tenemos se muestra en TikTok \u2014 cada piedra con su n\u00famero de informe IGI, sus medidas y su color bajo dos luces. Si busca una talla o un color en particular, d\u00edganoslo y lo buscamos.",
    cta:"Ver lo que hay en la bandeja",
    ctaSub:"@the_ara_atelier",
    alt:"Pedir una piedra espec\u00edfica"
  },

  ethics:{
    eyebrow:"Por qué importa",
    h:"Un diamante sin<br>nada <em>detrás.</em>",
    body:"Cada quilate extraído carga una historia que no se ve. Un diamante cultivado carga una que se puede leer — ningún pozo abierto, ningún cauce desviado, ningún yacimiento desplazado, ninguna presa de relaves que administrar el próximo siglo.",
    items:[
      ["Sin conflicto. Nunca.","Cultivado en un reactor sellado bajo un mismo techo. Sin mina, sin milicias, sin cadena de custodia que haya que creer a ciegas."],
      ["Sin tierra removida.","Sin pozo, sin escombrera, sin relaves, sin deuda de rehabilitación dejada a una comunidad."],
      ["El agua se queda donde está.","Ningún río desviado, ningún sedimento, ningún lodo de procesado que decantar después."],
      ["Una huella que puede mejorar.","La energía es el único insumo real, y la energía puede generarse limpia. Una mina no se puede des-excavar."]
    ],
    claim:"No afirmamos que todo diamante de laboratorio sea verde. Afirmamos que el nuestro puede decirle exactamente de dónde vino — y que ninguna parte de él se le quitó a nadie."
  },

  faq:{
    eyebrow:"Preguntas",
    h:"Preguntado y <em>respondido.</em>",
    items:[
      ["¿Un diamante de laboratorio es un diamante de verdad?",
       "Sí. La misma red de carbono, el mismo 10 en la escala de Mohs, el mismo brillo y fuego. No es moissanita ni circonita — esos son materiales distintos que imitan al diamante. Un diamante de laboratorio ES diamante; la única diferencia es dónde cristalizó."],
      ["¿Alguien podrá notarlo?",
       "A simple vista no, y con lupa tampoco. Un gemólogo necesita equipo especializado. Su informe IGI indica claramente que la piedra es cultivada en laboratorio, y muchas piedras llevan el número grabado en el cinturón."],
      ["¿Qué garantiza realmente un certificado IGI?",
       "Registra lo que el laboratorio midió: método de crecimiento, forma, quilates, grado de color, pureza, medidas, pulido, simetría y fluorescencia. Puede verificar cualquier informe usted mismo en igi.org, en Report Check, con el número — durante el vivo, antes de decidir."],
      ["¿Venden joyería terminada?",
       "Vendemos la piedra suelta. Los montajes se hacen a medida en el banco — anillo, colgante, pendientes o pulsera — y con gusto engastamos un diamante que ya tenga. Empiece por el formulario de encargo de esta página."],
      ["¿Cuánto cuesta un montaje?",
       "Cada encargo se presupuesta individualmente, porque el precio depende del diseño, del peso del metal y de la piedra que se engasta. Envíe el formulario de encargo y nuestro equipo responde con un presupuesto en 24 horas."],
      ["¿Cuánto tarda una pieza a medida?",
       "Hablar, boceto, CAD, cera, banco, revisión. Normalmente de tres a cinco semanas desde el CAD aprobado, según el diseño y según si la piedra está en la bandeja o todavía creciendo."],
      ["¿Es un diamante de laboratorio una buena inversión?",
       "No, y preferimos decirlo. El valor de reventa es modesto y los precios de la categoría llevan años cayendo. Cómprelo porque es hermoso y porque es el color y la talla que quería — no como activo."],
      ["¿Qué pasa si la piedra llega dañada o distinta a lo descrito?",
       "Se resuelve sin discusión. Lo que aparece en pantalla es lo que llega en la caja; ese es todo el sentido de mostrar el certificado primero."],
      ["¿Envían fuera de Estados Unidos?",
       "Sí, asegurado y con seguimiento. Los aranceles e impuestos de importación corren por cuenta del comprador y varían por país — escríbanos antes de pujar y le decimos qué esperar."],
      ["¿Puedo pedir una talla que no tengan?",
       "A menudo sí. La disponibilidad cambia cada semana y podemos encargar una forma. Díganos la talla, el color y los quilates que tiene en mente y le diremos con franqueza si es realista."],
      ["¿Hablan español?",
       "Sí. El vivo, la web y la documentación están disponibles en español."],
      ["¿Cómo hablo con una persona real?",
       "Pídale a Pamela hablar con un representante y ella tomará sus datos, o escriba a info@thearaatelier.com. Nuestro equipo responde en 24 horas, todos los días."]
    ]
  },

  contact:{
    eyebrow:"Contacto",
    h:"Escríba<em>nos.</em>",
    email:"Correo", tiktok:"TikTok", hours:"Horario", hoursV:"Todos los días",
    replies:"Respuestas", repliesV:"En 24 horas",
    cityLine:"The Ara Atelier · Nueva York",
    blurb:"Diamantes cultivados en laboratorio en formas raras y colores raros. Cada piedra certificada por IGI, cada montaje hecho a medida, cada pieza hecha una sola vez."
  },

  legal:{
    terms:"Términos y Condiciones", privacy:"Política de Privacidad", shipping:"Envíos y Devoluciones",
    back:"Volver al atelier", updated:"Última actualización",
    disclaimer:"Todos los diamantes que vende The Ara Atelier son cultivados en laboratorio y van acompañados de un informe IGI. Los diamantes de laboratorio son química, física y ópticamente idénticos a los extraídos de mina. Los precios se cotizan en dólares estadounidenses; las piedras y los montajes se cotizan por separado e individualmente. El color en pantalla varía según el dispositivo — el informe IGI es la descripción definitiva de cualquier piedra. Los diamantes de laboratorio no se venden como inversión y su valor de reventa es modesto. La disponibilidad cambia cada semana."
  },

  footer:{ rights:"Todos los derechos reservados", line:"Cultivado en laboratorio · Certificado IGI · Hecho a medida" },

  pam:{
    title:"Pamela", role:"Concierge del atelier",
    hello:"Buenas noches — soy Pamela, del atelier.\n\nPregúnteme por una forma, un color, qué compran realmente cincuenta días en el reactor, o cuánto costaría engastar una piedra que ya tiene. Si prefiere hablar con alguien del equipo, solo dígalo.",
    chips:["¿Qué es una marquesa holandesa?","¿Laboratorio o mina?","Engastar mi propia piedra","Hablar con un representante"],
    ph:"Pregunte por una piedra, una talla, un precio…",
    offline:"Escriba a info@thearaatelier.com",
    noReach:"No puedo alcanzar la línea del atelier desde aquí. Escriba a info@thearaatelier.com y el equipo responderá en 24 horas.",
    notGranted:"Necesitaría su permiso para responder desde aquí. info@thearaatelier.com llega directo al banco.",
    rateLimited:"Un momento — demasiadas preguntas a la vez. Inténtelo de nuevo en breve.",
    generic:"Algo falló de mi lado. info@thearaatelier.com llega directo al banco.",
    connecting:"Conectando…",
    leadOk:"Gracias — he pasado sus datos al equipo. Alguien se pondrá en contacto en las próximas 24 horas.",
    openForm:"Abrir el formulario de encargo"
  },

  seo:{
    title:"The Ara Atelier — Diamantes de Laboratorio de Color, Nueva York",
    desc:"Treinta y nueve tallas de diamante en nueve colores fancy, cada piedra certificada por IGI y grabada con láser. Cometa, pentágono, marquesa holandesa y oval escalonado, hechos a medida en Nueva York."
  }
}
};
